<template>
    <div v-if="$store.state.opened" style="z-index: 700000;" class="fixed inset-0" tabindex="-1">
        <component
            :is="$store.state.component"
            v-bind="$store.state.data"
            :close="() => $store.close()"
        ></component>
    </div>
</template>

<script>
import { modalStore } from '@stores'

export default {
    computed: {
        $store () {
            return modalStore
        },
    },
}
</script>
